import { render, staticRenderFns } from "./TimeWorkFilters.vue?vue&type=template&id=37a7abfb&"
import script from "./TimeWorkFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TimeWorkFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a7abfb')) {
      api.createRecord('37a7abfb', component.options)
    } else {
      api.reload('37a7abfb', component.options)
    }
    module.hot.accept("./TimeWorkFilters.vue?vue&type=template&id=37a7abfb&", function () {
      api.rerender('37a7abfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/TimeWorkFilters.vue"
export default component.exports